import { useMemo, type ReactNode } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { TrendIndicator } from './TrendIndicator';

interface MetricCardProps {
  title: string;
  value: number | null;
  change?: number | null;
  icon: ReactNode;
  format?: 'number' | 'score' | 'percent';
}

export function MetricCard({
  title,
  value,
  change,
  icon,
  format = 'number',
}: MetricCardProps) {
  const formattedValue = useMemo(() => {
    if (value === null || value === undefined) return '-';
    switch (format) {
      case 'score':
        return value.toFixed(0);
      case 'percent':
        return `${value.toFixed(1)}%`;
      default:
        return value.toLocaleString();
    }
  }, [value, format]);

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="body2" sx={{
            color: "text.secondary"
          }}>
            {title}
          </Typography>
          <Box sx={{ color: 'primary.main' }}>{icon}</Box>
        </Box>
        <Typography variant="h4" component="div">
          {formattedValue}
        </Typography>
        {change !== undefined && <TrendIndicator value={change ?? null} />}
      </CardContent>
    </Card>
  );
}
